import { render } from "./ChatMessageCards.vue?vue&type=template&id=5ef386a7"
import script from "./ChatMessageCards.vue?vue&type=script&lang=js"
export * from "./ChatMessageCards.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__